




































































import { Component, Mixins, Watch, Vue } from 'vue-property-decorator'
import ZkTable from 'vue-table-with-tree-grid'
import CustomForm from '@/components/custom-form/index.vue'
import AbpBase from '@/lib/abpbase'
import CategoryApi from '@/api/goods/category'

@Component({
  components: {
    [ZkTable.name]: ZkTable,
    CustomForm,
  },
})
export default class GoodsCategory extends AbpBase {
  filters = [
    {
      label: '输入搜索：',
      type: 'input',
      props: {
        placeholder: '商品分类名称',
      },
      key: 'keyWord',
    },
  ]
  columns: any[] = [
    {
      label: '分类名称',
      prop: 'name',
    },
    {
      label: '图片',
      type: 'template',
      template: 'picture',
    },
    // {
    //   label: '隐藏/显示',
    //   type: 'template',
    //   template: 'published'
    // },
    {
      label: '排序',
      prop: 'displayOrder',
    },
    {
      label: '操作',
      type: 'template',
      template: 'action',
      width: 270,
      align: 'center',
    },
  ]
  loading: boolean = false
  tableData: any[] = []

  submitChange(form, valid) {
    if (valid) {
      this.getData()
    }
  }

  submitFn() {
    let form: any = this.$refs.lineForm
    form.submit()
  }

  created() {
    this.getData()
  }

  /**
   * 获取所有分类
   */
  getData() {
    let form: any = this.$refs.lineForm
    console.log(form)
    const formData = (form && form.getForm()) || { keyWord: '' }
    if (formData.keyWord) {
      CategoryApi.listByKeyWord(formData.keyWord).then((res) => {
        this.tableData = res.data.items
      })
    } else {
      CategoryApi.getAll().then((res) => {
        this.tableData = this.listToTree(res.data.items)
      })
    }
  }

  /**
   * 删除分类
   */
  deleteBrand(row: any) {
    this.$Modal.confirm({
      title: '提示',
      content: `删除无法恢复, 是否继续?`,
      onOk: () => {
        this.handleDelete(row.id)
      },
    })
  }

  handleDelete(id: string | number) {
    CategoryApi.deleteById(id).then((res) => {
      this.getData()
    })
  }

  listToTree(list) {
    let map = {},
      node,
      roots = []
    for (let i = 0; i < list.length; i += 1) {
      map[list[i].id] = i
      list[i].children = []
    }
    for (let i = 0; i < list.length; i += 1) {
      node = list[i]
      if (node.parentId !== null) {
        if (map[node.parentId] != null) {
          list[map[node.parentId]].children.push(node)
        }
      } else {
        roots.push(node)
      }
    }
    return roots
  }

  handleBeforeChange() {
    return new Promise((resolve, reject) => {
      return reject()
    })
  }
}
